<template>
  <div
    :id="navId"
    class="article-product-standout-container"
    :class="containerClasses"
  >
    <div class="article-product-standout" :class="classes">
      <div class="media1">
        <AddFromVideo
          v-if="videoUrl"
          :product-handle="productHandle2"
          :video-url="videoUrl"
        />
        <IntersectionObserver v-if="videoUrl2" v-slot="{ intersected }">
          <Video
            :intersected="intersected"
            :video="{
              sources: [
                {
                  url: videoUrl2,
                },
              ],
            }"
          />
        </IntersectionObserver>
        <AddFromPhoto
          v-if="productHandle"
          :product-handle="productHandle"
          :image-url="mainImage"
          class="mainImage2"
        />
        <Picture v-if="mainImage2" :images="mainImage2" class="mainImage2" />
      </div>
      <div class="text-box" :class="textClasses">
        <div class="image3">
          <AddFromPhoto
            v-if="productHandle3"
            :product-handle="productHandle3"
            :image-url="mainImage3"
            class="image3"
          />
        </div>
        <Picture v-if="mainImage4" :images="mainImage4" class="image3" />
        <div v-if="heading" class="heading">{{ heading }}</div>
        <div class="text">
          <slot v-if="activeSlot === 1" name="content"></slot>
          <slot v-else-if="activeSlot === 2" name="content-es"></slot>
          <template v-if="contentReadMoreExists">
            <div
              :class="{
                'readMore--hidden': !readMore,
                'readMore--show': readMore,
              }"
            >
              <slot name="content-read-more"></slot>
            </div>
            <button class="read-more-button" @click="toggleReadMore">
              {{ readMoreButton }}
            </button>
          </template>
        </div>
        <button
          v-if="contentEsExists"
          class="langButton"
          :class="langButtonClasses"
          @click="toggleSlot"
        >
          <span>EN</span> |
          <span>ES</span>
        </button>

        <div class="flatlays">
          <Picture v-if="flatlayOne" class="flatlay" :images="flatlayOne" />
          <Picture v-if="flatlayTwo" class="flatlay" :images="flatlayTwo" />
        </div>
        <div>
          <AddFromVideo
            v-if="videoUrl"
            :product-handle="productHandle4"
            :video-url="videoUrl3"
          />
          <IntersectionObserver v-if="videoUrl4" v-slot="{ intersected }">
            <Video
              :intersected="intersected"
              :video="{
                sources: [
                  {
                    url: videoUrl4,
                  },
                ],
              }"
            />
          </IntersectionObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
import AddFromPhoto from "@/components/AddFromPhoto.vue";
import AddFromVideo from "@/components/AddFromVideo.vue";
import Video from "@/components/Video.vue";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
export default {
  name: "ArticleProductStandout",
  components: {
    Picture,
    AddFromPhoto,
    AddFromVideo,
    Video,
    IntersectionObserver,
  },
  props: {
    mainImage: {
      type: Object,
      default: null,
    },
    mainImage2: {
      type: Object,
      default: null,
    },
    mainImage3: {
      type: Object,
      default: null,
    },
    mainImage4: {
      type: Object,
      default: null,
    },
    videoUrl: {
      type: String,
      default: null,
    },
    videoUrl2: {
      type: String,
      default: null,
    },
    videoUrl3: {
      type: String,
      default: null,
    },
    videoUrl4: {
      type: String,
      default: null,
    },
    productHandle: {
      type: String,
      default: null,
    },
    productHandle2: {
      type: String,
      default: null,
    },
    productHandle3: {
      type: String,
      default: null,
    },
    productHandle4: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    flatlayOne: {
      type: Object,
      default: null,
    },
    flatlayTwo: {
      type: Object,
      default: null,
    },
    flip: {
      type: Boolean,
      default: false,
    },
    end: {
      type: Boolean,
      default: false,
    },
    quote: {
      type: Boolean,
      default: false,
    },
    quoteMobile: {
      type: Boolean,
      default: false,
    },
    columnGap: {
      type: Boolean,
      default: false,
    },
    navId: {
      type: String,
      default: null,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    textCenter: {
      type: Boolean,
      default: false,
    },
    overlapPreviousComponent: {
      type: Boolean,
      default: false,
    },
    imageWidth90Percent: {
      type: Boolean,
      default: false,
    },
    greyBackground: {
      type: Boolean,
      default: false,
    },
    styleSeries: {
      type: Boolean,
      default: false,
    },
    columnPadding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeSlot: 1,
      readMore: false,
    };
  },
  computed: {
    textClasses() {
      return {
        "article-product-standout--end": this.end,
        "article-product-standout--centered": this.centered,
        "article-product-standout--columnGap": this.columnGap,
        "article-product-standout--quote": this.quote,
        "article-product-standout--textCenter": this.textCenter,
        "article-product-standout--quoteMobile": this.quoteMobile,
      };
    },
    classes() {
      return {
        "article-product-standout--flip": this.flip,
        "article-product-standout--columnGap": this.columnGap,
        "article-product-standout--image-width-90-percent":
          this.imageWidth90Percent,
        "article-product-standout--greyBackground": this.greyBackground,
        "article-product-standout--styleSeries": this.styleSeries,
        "article-product-standout--columnPadding": this.columnPadding,
      };
    },
    containerClasses() {
      return {
        "article-product-standout-container--overlapPreviousComponent":
          this.overlapPreviousComponent,
      };
    },
    langButtonClasses() {
      return {
        "langButton--en": this.activeSlot === 1,
        "langButton--es": this.activeSlot === 2,
      };
    },
    readMoreButton() {
      return this.readMore ? "Read Less" : "Read More";
    },
    contentEsExists() {
      return !!this.$slots["content-es"];
    },
    contentReadMoreExists() {
      return !!this.$slots["content-read-more"];
    },
  },
  methods: {
    toggleSlot() {
      console.log("toggleSlot");
      this.activeSlot = this.activeSlot === 1 ? 2 : 1;
    },
    toggleReadMore() {
      this.readMore = !this.readMore;
    },
  },
};
</script>

<style lang="scss" scoped>
.article-product-standout-container {
  margin: 0 auto 45px;
  max-width: 1600px;

  @include respond-above(md) {
    padding: 0 20px;
    margin: 0 auto 80px;
  }

  &--overlapPreviousComponent {
    direction: rtl;
    margin: -200px auto 80px;
    max-width: 1600px;
    .media1 {
      display: flex;
      align-items: end;
      justify-content: center;
    }
    .mainImage2 {
      width: 550px;
    }
    .image3 {
      width: 500px;
      margin: 0 auto 50px;
    }
    .text-box {
      margin: 0 20px 0;
    }
    .text {
      margin: 0 20px 0;
      text-align: center;
    }
  }
}
.article-product-standout {
  @include respond-above(md) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 100px;
  }

  &--flip {
    display: flex;
    flex-direction: column-reverse;
    margin: 0 auto 60px;

    @include respond-above(md) {
      direction: rtl;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      margin: 0 auto 80px;
    }

    .text {
      margin: 0 20px 60px;
    }
  }

  &--end {
    align-items: end;
    justify-content: end;
    display: flex;
    flex-direction: column;
  }

  &--textCenter {
    .text {
      text-align: center;
    }
  }

  &--centered {
    align-items: center;
    display: flex;
  }

  :deep(p) {
    @include t__editorial-body-10;
    @include respond-above(md) {
      @include t__editorial-body-20;
    }
  }

  &--columnGap {
    @include respond-above(md) {
      grid-column-gap: 50px;
    }
  }

  &--image-width-90-percent {
    .mainImage2 {
      :deep(.image) {
        width: 90%;
        margin: 0 50px;
      }
    }
  }

  &--quote {
    display: flex;
    direction: initial;
    flex-direction: column;
    justify-content: center;

    :deep(p) {
      @include t__editorial-sub-headline-20;
      text-align: center;
      @include respond-above(md) {
        @include t__editorial-sub-headline-30;
      }
    }
  }

  &--quoteMobile {
    align-items: center;
    display: flex;
    direction: initial;

    :deep(p) {
      @include t__editorial-sub-headline-20;
    }
  }
  &--greyBackground {
    background-color: #fafafa;
  }
  &--styleSeries {
    .media1 {
      padding: 80px;
    }
    .text-box {
      margin-bottom: 60px;
      max-width: 500px;
      :deep(.video__wrapper) {
        padding: 50px 50px 50px 0;
      }
    }
    .text {
      :slotted(h4) {
        font-size: 28px;
      }
    }
  }
  &--columnPadding {
    .media1 {
      padding: 100px 100px 0 0;
      direction: ltr;
    }
    .text-box {
      padding: 80px 0 0 80px;
    }
  }
}

.flatlays {
  @include respond-above(md) {
    display: flex;
    gap: 13px;
    margin-top: 50px;
    justify-content: center;
  }
}

:deep(h3) {
  font-size: 36px;
  text-transform: uppercase;
  font-family: $heading-font-family;
  font-weight: 400;
  margin-bottom: 20px;
}

:deep(h4) {
  @include t__editorial-headline-10;
  margin-bottom: 10px;
  @include respond-above(md) {
    @include t__editorial-headline-20;
  }
}
:slotted(h5) {
  text-transform: uppercase;
  font-family: $utility-font-family;
  text-align: left;
  font-size: 16px;
  font-weight: 400;
  margin: 0 20px;
}
:slotted(h6) {
  font-style: italic;
  text-align: left;
  font-size: 50px;
  font-weight: 400;
  margin: 0 20px 50px;
}

.flatlay {
  max-width: 214px;
}

.heading {
  direction: initial;
  @include t__editorial-headline-10;
  text-align: left;
  margin-left: 5%;
  margin-bottom: 10px;
  @include respond-above(md) {
    @include t__editorial-headline-20;
  }
}

.text {
  margin: 80px 30px 0;
  text-align: left;
  @include respond-above(md) {
    text-align: center;
  }

  @include respond-above(md) {
    direction: initial;
    font-family: $heading-font-family;
    // margin: 5% 5% 15px;
    text-align: left;
  }
}

:slotted(span) {
  display: block;
  font-family: $heading-font-family;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  font-style: italic;
  margin: 20px 0;
  @include respond-above(md) {
    font-size: 18px;
  }
}

:slotted(p) {
  display: inline-block;
  @include t__editorial-body-10;
  margin: 0 0 20px 0;
  @include respond-above(md) {
    @include t__editorial-body-20;
  }
}

:slotted(a) {
  font-family: $utility-font-family;
  font-weight: 400;
  font-size: 14px;
}

:slotted(p + h4) {
  margin-top: 45px;

  @include respond-above(md) {
    margin-bottom: 10px;
    margin-top: 60px;
  }
}
.langButton {
  background: none;
  border: none;
  font-family: $heading-font-family;
  font-size: 18px;
  font-weight: 400;
  margin: 25px 5%;
  padding: 0;
  text-align: left;
  @include respond-above(md) {
    font-size: 20px;
  }

  &--en {
    span {
      &:first-child {
        font-weight: 700;
      }
    }
  }

  &--es {
    span {
      &:last-child {
        font-weight: 700;
      }
    }
  }
}
.readMore {
  &--hidden {
    display: none;
  }
  &--show {
    display: block;
  }
}
.read-more-button {
  background: none;
  border: none;
  font-family: $utility-font-family;
  font-size: 20px;
  font-weight: 400;
  padding: 0;
  text-decoration: underline;
}
</style>
